import { useEffect } from 'react';
import { ALLOW_COOKIE } from 'constants';
import { deleteCookie } from 'utilities/logoutHelper';

export const useDeleteCookies = preLoaderActions => {
    useEffect(() => {
        ALLOW_COOKIE && deleteCookie();
        preLoaderActions.hidePreLoader();
        // eslint-disable-next-line
    }, []);
};
